module.exports = __webpack_public_path__ + "img/CHECK@3x.2e983b2f.png";